export default __webpack_public_path__ + "static-front/media/PhoneIcon.b4fe9d38.svg";